function ArrayListController($scope) {
  const ctrl = this;
  $scope.order = {
    field: 'name',
    reverse: false
  };

  ctrl.$onInit = () => { };

  $scope.conditionOrder = function(condition) {
    return condition[$scope.order.field];
  }

  $scope.changeOrderField = function() {
    if ($scope.order.field === 'name') {
      $scope.order.field = 'id';
    } else {
      $scope.order.field = 'name';
    }
  }

  $scope.reverseOrder = function() {
    $scope.order.reverse = !$scope.order.reverse;
  }
}

angular
  .module('pis-common.module')
  .controller('ArrayListController', ArrayListController);
